import decodeJwtToken from 'civic-champs-shared/auth/utils/decodeJwtToken'

import { Auth } from './legacyAuth'

export async function getAuthorizationToken() {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      const payload = decodeJwtToken(token)
      if (payload.exp * 1000 > Date.now()) {
        return `scheduler:${token}`
      }
      localStorage.removeItem('token')
      localStorage.removeItem('firstLogin')
    } catch (e) {
      localStorage.removeItem('token')
      localStorage.removeItem('firstLogin')
    }
  }

  const session = await Auth.currentSession()
  return session.getIdToken().getJwtToken()
}
